export const QA_GET_PRODUCTS_LISTING = "QA_GET_PRODUCTS_LISTING"
export const QA_GET_PRODUCTS_LISTING_SUCCESS = "QA_GET_PRODUCTS_LISTING_SUCCESS"
export const QA_GET_PRODUCTS_LISTING_FAILED = "QA_GET_PRODUCTS_LISTING_FAILED"

export const QA_PRODUCT_EDIT = "QA_PRODUCT_EDIT"
export const QA_PRODUCT_EDIT_SUCCESS = "QA_PRODUCT_EDIT_SUCCESS"
export const QA_PRODUCT_EDIT_FAIL = "QA_PRODUCT_EDIT_FAIL"
